import { gql, useQuery } from "@apollo/client";
import { useState } from "react";

const useNode = (
  nodeId: number | null
): {
  imageIds: number[];
  loading: boolean;
  error: Error | undefined;
} => {
  const [imageIds, setImageIds] = useState<number[]>([]);

  const { loading, error } = useQuery<{
    node: { galleryIds: number[] | null };
  }>(
    gql`
      query LoadNodeGallery($id: Int!) {
        node(id: $id) {
          galleryIds
        }
      }
    `,
    {
      skip: !nodeId,
      variables: {
        id: nodeId,
      },
      onCompleted(data) {
        if (data && data.node && data.node.galleryIds) {
          setImageIds(data.node.galleryIds);
        }
      },
    }
  );
  return {
    imageIds,
    loading,
    error,
  };
};


export default useNode;